import { render, staticRenderFns } from "./MoreProfileHeader.vue?vue&type=template&id=527144c4&scoped=true&"
import script from "./MoreProfileHeader.vue?vue&type=script&lang=ts&"
export * from "./MoreProfileHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MoreProfileHeader.vue?vue&type=style&index=0&id=527144c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527144c4",
  null
  
)

export default component.exports